import Vue from "vue";

export function downLoad(url, name) {
    var xReq = new XMLHttpRequest();
    xReq.open("GET", url, true);
    xReq.responseType = "blob";
    xReq.onload = function () {
        var url = window.URL.createObjectURL(xReq.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = name;
        a.click();
        a.remove();
    };
    xReq.send();
}

Vue.prototype.$download = downLoad